import React, { useState, useEffect, useRef } from 'react';
import mixClass from 'classnames';
import styles from './index.less';

export const TextMessage = ({item}) => {
    const ref = useRef(null);
    const [isShow, setIsShow] = useState(false);
    const [isExpand, setIsExpand] = useState(false);

    useEffect(() => {
        const { clientHeight } = ref.current;
        const { lineHeight } = window.getComputedStyle(ref.current);
        setIsShow(clientHeight > parseFloat(lineHeight) * 4)
    }, [item?.content?.text]);

    const onClick = () => {
        setIsExpand(!isExpand);
    };

    return (
        <div className={styles.textMessage}>
            <div
                ref={ref}
                className={mixClass(styles.messageItem, { [styles.textCollapse]: isShow && !isExpand })}
                dangerouslySetInnerHTML={{ __html: item.content.text.replace(/þ_enter_þ/g, '<br/>') }}/>
                {isShow &&
                    (isExpand ? <div className={styles.collapseBtn} onClick={onClick}>收起</div> :
                        <div className={styles.expandBtn} onClick={onClick}>全文</div>
                    )
                }
        </div>
    );
}

export const PicMessage = ({ item }) => {
    return <img className={styles.picMessage} src={item.content.picUrl} alt="上传的图片" />;
}

export const VideoMessage = ({ item }) => {
    return (
        <div className={styles.videoMessage}>
            <video className={styles.videoCover} id="videoSource" preload="metadata">
                <source src={`${item.content.videoUrl}#t=0.1`} type="video/mp4" />
                不支持 video 标签
            </video>
            <img
                src="https://qa-pcrm.shuyun.com/pcrm/202207/e2f5f56627cbabf6e6790fe70503cefe/140605_63376_媒体／play-circle-fill@2x.png"
                className={styles.playIcon}
                alt=""/>
        </div>
    );
}

export const UrlMessage = ({ item }) => {
    const { title, picUrl } = item.content;
    return (
        <div className={mixClass(styles.messageItem, styles.urlMessage)}>
            <img src={picUrl} className={styles.cover} alt="" />
            <div className={styles.urlTitle}>{title}</div>
        </div>
    );
}

